import _ from "underscore";

function getProductSuppliersForStore(storeProductSuppliers, suppliers, storeID, date){
    return storeProductSuppliers.filter(sPS => {
        if(!storeID){
            return false;
        }

        if(storeID != sPS.StoreID){
            return false;
        }

        let supplier = suppliers.find(s => s.ID == sPS.SupplierID);
        if(!supplier){
            return false;
        }

        if(!supplier.Active){
            return false;
        }

        return true;
    }).map(sPS => {
        let supplier = Object.assign({}, suppliers.find(s => s.ID == sPS.SupplierID));

        supplier.Quantity = sPS.Quantity;
        supplier.Priority = sPS.Priority;
        supplier.ProductID = sPS.ProductID;

        return supplier;
    });
}

function getCategoriesForDepartment(categories, departmentID){
    return categories.filter(c => _.some(c.Departments, function (y) { return y.DepartmentID == departmentID }));
}

function getProductsWithCategoryForDepartment(products, categoriesForDepartment){
    return products.filter(p => p.CategoryID && categoriesForDepartment.some(c => c.ID == p.CategoryID));
}

function getSuppliersForProduct(productSuppliersForStore, productID){
    return productSuppliersForStore.filter(sPFS => sPFS.ProductID == productID).sort(sortByPriority);
}

function getProductsWithSuppliers(productSuppliersForStore, productsWithCategoryForDepartment){
    // Filter out any products which do not have a supplier
    return productsWithCategoryForDepartment.map(p => {
        let product = Object.assign({}, p);

        // Search supplierProducts for applicable suppliers which supply this product
        product.Suppliers = getSuppliersForProduct(productSuppliersForStore, p.ID);

        return product;

    // Filter out any products which do not have a supplier
    }).filter(p => p.Suppliers.length > 0);
}

// Most prioritised to least prioritised
function sortByPriority(a, b){
    if(a.Priority && !b.Priority){ // Null priority is least prioritised
        return -1;
    }

    if(!a.Priority && b.Priority){ // Null priority is least prioritised
        return 1;
    }

    if(a.Priority < b.Priority){ // Smallest priority is most prioritised
        return -1;
    }

    if(a.Priority > b.Priority){ // Smallest priority is most prioritised
        return 1;
    }

    return 0;
}

function getCategoriesWithProducts(categoriesForDepartment, productsWithSuppliers){
    return categoriesForDepartment.filter(c => productsWithSuppliers.some(p => p.CategoryID == c.ID));
}

function getProductsAndCategories(storeSuppliers, suppliers, storeID, date, categories, departmentID, products){
    let productSuppliersForStore = getProductSuppliersForStore(storeSuppliers, suppliers, storeID, date);
    let categoriesForDepartment = getCategoriesForDepartment(categories, departmentID);
    let productsWithCategoryForDepartment = getProductsWithCategoryForDepartment(products, categoriesForDepartment);
    let productsWithSuppliers = getProductsWithSuppliers(productSuppliersForStore, productsWithCategoryForDepartment);
    let categoriesWithProducts = getCategoriesWithProducts(categoriesForDepartment, productsWithSuppliers);

    return {
        productsWithSuppliers,
        categoriesWithProducts
    };
}

function combineSameProducts(orderProducts){
    let orderProductsCombined = [];

    for(let i = 0; i < orderProducts.length; i++){
        let orderProduct = orderProducts[i];

        let combinedOrderProduct = orderProductsCombined.find(oPC => oPC.Product.ID == orderProduct.Product.ID);
        if(!combinedOrderProduct){
            orderProductsCombined.push(Object.assign({}, orderProduct));
            continue;
        }

        combinedOrderProduct.Quantity += orderProduct.Quantity;
    }

    return orderProductsCombined;
}

function splitProductsBySupplierQuantity(productSuppliersForStore, orderProducts){
    let orderProductsSplitBySupplierQuantity = [];

    for(let i = 0; i < orderProducts.length; i++){
        let orderProduct = orderProducts[i];

        let suppliersRemaining = getSuppliersForProduct(productSuppliersForStore, orderProduct.Product.ID);
        let quantityRemaining = orderProduct.Quantity;
        while(quantityRemaining > 0){
            let newOrderProduct = Object.assign({}, orderProduct);
            newOrderProduct.Supplier = suppliersRemaining[0];
            let maxQuantity = newOrderProduct.Supplier.Quantity;
            
            // If there are more suppliers, then use up all this supplier's quantity
            if(suppliersRemaining.length > 1){
                newOrderProduct.Quantity = maxQuantity;
            // If this is the last supplier, then use up the remaining quantity
            } else {
                newOrderProduct.Quantity = quantityRemaining;
            }

            // If quantity is null, use all the remaining quantity
            if(newOrderProduct.Quantity == null){
                newOrderProduct.Quantity = quantityRemaining;
            }

            // Never use more than the remaining quantity
            if(newOrderProduct.Quantity > quantityRemaining){
                newOrderProduct.Quantity = quantityRemaining;
            }

            suppliersRemaining.splice(0, 1);
            quantityRemaining -= newOrderProduct.Quantity;
            orderProductsSplitBySupplierQuantity.push(newOrderProduct);
        }
    }

    return orderProductsSplitBySupplierQuantity;
}

export default {
    getProductSuppliersForStore,
    getCategoriesForDepartment,
    getProductsWithCategoryForDepartment,
    getProductsWithSuppliers,
    sortByPriority,
    getCategoriesWithProducts,
    getProductsAndCategories,
    combineSameProducts,
    splitProductsBySupplierQuantity
};